import React from 'react'
import { Market } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { getEnumValues, MarketHelper } from 'model'

export type MarketSelectboxProps = Omit<SelectboxProps<Market, Market>, 'optionKeys'>

export const MarketSelectbox = React.forwardRef((props: MarketSelectboxProps, ref: React.Ref<Selectbox>) => {
  const optionKeys = getEnumValues(Market)
  return <Selectbox ref={ref} optionKeys={optionKeys} getOptionText={MarketHelper.getName} {...props} />
})

export const MarketSelectboxField = Field(MarketSelectbox)
